<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-30 14:21:30
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;
      .el-input {
        width: auto;
      }
    }
    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }
    &_pagenation {
      margin: 40px auto;
    }
  }
  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
            clearable
            v-model="search.searchKey"
            clas="input_search"
            placeholder="搜索关键字"
            @keyup.enter.native="SearchDictionaryList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
              v-for="item in COMMON_STATUS"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchDictionaryList"
            >查询</el-button
          >
          <el-button
              v-if="addShow"
            size="medium"
            type="primary"
            @click="handleClick('addNext')"
            >新增</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            v-loading="loading"
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                  (page.pageNo - 1) * page.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="enumCode" label="代码" min-width="150">
            </el-table-column>
            <el-table-column prop="enumName" label="名称" min-width="150">
            </el-table-column>
            <el-table-column prop="enumVal" label="值" min-width="150">
            </el-table-column>
            <el-table-column prop="enumIcon" label="图标">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.enumIcon"
                  style="width:30px; height: 30px"
                  :src="scope.row.enumIcon"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="enumDescr" label="说明" min-width="180">
            </el-table-column>
            <el-table-column prop="enumSeq" label="排序"> </el-table-column>
            <el-table-column prop="enumStatus" label="状态" min-width="80">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                  v-model="scope.row.enumStatus"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('change', scope.row)"
                  plain
                  v-if="editShow"
                  size="small"
                  >修改</el-button
                >
                <el-button
                    v-if="deleteShow"
                  type="primary"
                  plain
                  size="small"
                  @click="del(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      :title="
        clickType == 'change'
          ? '修改字典信息'
          : clickType == 'addNext'
          ? '新增字典信息'
          : ' 字典信息'
      "
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="480px"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-row>
            <el-col :span="23">
              <el-form-item label="值："  prop="enumVal">
                <el-input
                  clearable
                  placeholder="填写值"
                  v-model="params.enumVal"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        
          <el-row>
            <el-col :span="11">
              <el-form-item label="名称：" prop="enumName" >
                <el-input
                  clearable
                  placeholder="字典名称"
                  v-model="params.enumName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代码：" prop="enumCode" >
                <el-input
                  :disabled="clickType == 'change' ? true : false "
                  clearable
                  placeholder="字典代码"
                  v-model="params.enumCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-form-item
            label="ICON："
            class="item"
            v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <!--图片部分-->
            <div class="screenshot">
              <span
                v-for="(imgUrl, index) in srcList"
                :key="index"
                class="slideshow"
              >
                <div
                  class="icon-close"
                  @click="removeUploading(index)"
                  v-if="isMoer"
                >
                  <i class="el-icon-close"></i>
                </div>
                <el-image
                  style="width:35px; height: 35px; border-radius: 6px"
                  :src="imgUrl"
                  fit="cover"
                  @click="getPolicy"
                />
              </span>
              <div
                v-loading="loading1"
                class="up-btn"
                style="width: 35px; height: 35px; line-height:45px"
                @click="getPolicy"
                v-if="isMoer"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <input type="file" ref="file" @change="getFile" />
          </el-form-item>

          <el-row >
            <el-col :span="23">
              <el-form-item label="排序：" prop="enumSeq">
                <el-input
                  clearable
                  placeholder="排序序号(只允许数字值)"
                  v-model.number="params.enumSeq"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="23">
              <el-form-item label="说明：" prop="enumDescr">
                <el-input type="textarea" :rows="4" placeholder="最长为200个字符" v-model="params.enumDescr" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { PAGE_SIZE, COMMON_STATUS } from "@/config";

import { ossUpload } from "@utils/filters/upload";

export default {
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,

      loading1: false, //加载中

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        enumName: [
          { required: true, message: "请填写名称", trigger: "change" },
          // { max: 10, message: "不超过10个字符" },
        ],
        enumVal: [ { required: true, message: "请填写值", trigger: "change" },],
        enumCode: [ { required: true, message: "请填写代码", trigger: "change" },],
        enumSeq:[{type: 'number', message: "请填写序号(数字)", trigger: "blur" }]
      }, //表单验证提示

      tableData: [], //二级--列表
      srcList: [], //上传图片数组
      isMoer: true,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  created() {
    this.getVipRightList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.isMoer = true;
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:enums:query') {
            this.searchShow = true
          }
          if (item.code == 'system:enums:add') {
            this.addShow = true
          }
          if (item.code == "system:enums:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:enums:edit") {
            this.editShow = true
          }
          if (item.code == "system:enums:status") {
            this.statusShow = false
          }
        })
      }
    },

    SearchDictionaryList(){
       this.page.pageNo = 1
       this.getVipRightList()
    },
    /**
     *  get list 字典列表
     */
    async getVipRightList() {
      let http = "/enums/list";
      this.loading = true;
      const { data: resData } = await this.$get(http, {
        params: { ...this.search, ...this.page },
      });
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
      this.page.count = resData.page.count;
    },

    //switch状态改变 --接口
    handleSwitch(index) {
      //interface
      this.$put(
        `/enums/info/status/${this.tableData[index].enumCode}/${this.tableData[index].enumVal}`
      ).then(res=>{
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        //回显图片
        if (row.enumIcon) {
          this.srcList = [];
          this.isMoer = false;
          this.srcList.push(row.enumIcon);
        } else {
          this.srcList = [];
          this.isMoer = true;
        }
      } else {
        //添加
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            if (this.srcList.length) {
              this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
            }
            const { data: resData } = await this.$post(
              "/enums/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );
            if (resData.result != 200) return;
            this.getVipRightList(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改
              if (this.srcList.length) {
                this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
              }
              const { data: resData } = await this.$post(
                `/enums/info`,
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
              );
              if (resData.result != 200) return;
              this.getVipRightList(); //重新获取数据
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
                  `/enums/info/${row.enumCode}/${row.enumVal}`,

          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipRightList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipRightList();
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.loading1 = true;
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.file.files[0],
        resData.data,
        "one" //'more','one'
      );
      this.isMoer = false;
      this.loading1 = false;

      this.srcList = addRoutes;
      this.params.enumIcon = this.srcList[0];
    },
  },
};
</script>
